module.exports = __webpack_public_path__ + "img/click_select_pdf.f9b14069.png";